import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { resetFilter } from 'core/search/redux/action';
import { connect } from 'react-redux';
import DeviceDetailComponent from './device-detail-component';

const mapStateToProps = (state: ApplicationState) => ({
  navbar: state.navbar.navbar,
  general: state.devices.detail.general,
})

export default connect(mapStateToProps, { openModal, closeModal, resetFilter })(DeviceDetailComponent);
